import React, {useState, useEffect } from "react";
// import "../styles/moowr.css";

// import step1 from "../assets/step1.png";
// import step2 from "../assets/step2.png";
// import step3 from "../assets/step3.png";
// import approved from "../assets/approved.png";
import moowr from "../assets/moowr.jpeg";

export default function MoowrScheme() {
  const [open, setOpen] = useState(0);
  const [activeSection, setActiveSection] = useState(0);

  const menu = [
    "Overview",
    "Advantages of Bonded Manufacturing",
    "Types of Beneficiaries",
    "Steps to Start Manufacturing",
    "Steps for Clearance of Warehoused Goods",
    "Essentials to Benefit from Bonded Manufacturing",
    "Requirements for Record-keeping"
  ];

  const stepData = [
  "In order to transfer goods from one warehouse to another, the following conditions must be met.",
  "Complete the Form for Transfer of Goods from a facility provided in the Warehouse Goods (Removal) Regulations Act, 2016.",
  "The licensee of the originating warehouse must attach a one-time lock on transport.",
  "Present the acknowledgement received from the recipient warehouse confirming arrival of goods.",
  "If the one-time lock is found intact, allow unloading and verify number of goods.",
  "Any discrepancy in number of goods must be reported within twenty-four hours.",
  "Endorse the transfer form with quantity received and retain a copy."
];

     const items = [
    {
      title: "Export goods",
      content: (
        <>
          <p>
            No duty needs to be paid on imported raw materials or capital goods
            if the following requirements are fulfilled:
          </p>
          <ul>
            <li>
              Proper documents of export declaration such as Shipping Bill,
              Bill of Export or prescribed form.
            </li>
            <li>Export duty, fines and penalties are duly paid.</li>
            <li>An order of clearance of goods is issued by Customs Officer.</li>
          </ul>
        </>
      ),
    },
    {
      title: "Goods for home consumption",
      content: (
        <p>
          Duty payment for imported raw materials may also be required through
          an ex-Bond Bill of Entry at the time of supplying finished goods.
        </p>
      ),
    },
    {
      title: "Waste / refused goods",
      content: (
        <>
          <p>
            If any waste or refuse is generated during allowable operations on
            warehoused goods, the following rules apply:
          </p>
          <ul>
            <li>
              If exported, import duty may be waived on quantity contained in
              waste or refuse.
            </li>
            <li>
              If cleared for domestic consumption, import duty shall be levied.
            </li>
          </ul>
        </>
      ),
    },
  ];

  useEffect(() => {
  const handleScroll = () => {
    let current = 0;

    menu.forEach((_, index) => {
      const section = document.getElementById(`sec${index}`);
      if (!section) return;

      const rect = section.getBoundingClientRect();

      // section visible in viewport
      if (rect.top <= window.innerHeight * 0.4) {
        current = index;
      }
    });

    setActiveSection(current);
  };

  window.addEventListener("scroll", handleScroll);
  handleScroll();

  return () => window.removeEventListener("scroll", handleScroll);
},);

  return (
    <div className="moowr-page">

      <div className="moowr-wrapper">

        {/* LEFT SIDEBAR */}
        <aside className="moowr-sidebar">
          {menu.map((item, i) => (
            <a key={i} href={`#sec${i}`} className={`side-item ${activeSection === i ? "active" : ""}`}>
              <span>0{i + 1}</span> {item}
            </a>
          ))}
        </aside>

        {/* RIGHT CONTENT */}
        <div className="right-content">

  {/* ================= OVERVIEW ================= */}
  {/* ================= OVERVIEW ================= */}
<section className="moowr-section" id="sec0">

  <h2 className="green-title">Overview</h2>

  <h1 className="main-heading">
    India permits the establishment of bonded manufacturing facilities
    where various operations, including manufacturing, can be conducted.
  </h1>

  <p>
    As part of the Indian government's ongoing efforts to position India as a
    global manufacturing hub and improve ease of doing business, the Central
    Board of Indirect Taxes (CBIC) has introduced a new initiative.
    This initiative allows for the import of raw materials and capital goods
    into bonded manufacturing facilities without the need for immediate payment
    of import duty, which is deferred.
  </p>

  <p>
    If these imported inputs are used for manufacturing goods that are
    subsequently exported, the deferred duty is exempted. Import duty on
    imported raw materials used in production is only required to be paid when
    finished goods are cleared for domestic market.
  </p>

  {/* IMAGE EXACT POSITION */}
  <div className="overview-image-box">
    <img
      src={moowr}
      alt="Private Bond Facility"
      className="overview-img"
    />
  </div>

  <p className="note-text">
    <strong>Note :</strong> When raw materials or capital goods are imported, the import duty is deferred, meaning it does not need to be paid immediately. If these imported inputs are used for manufacturing goods that are subsequently exported, the deferred duty is exempted, along with a waiver of Basic Customs Duty (BCD) and Integrated Goods and Services Tax (IGST) on the imported goods used. Additionally, when the finished goods are exported, the Goods and Services Tax (GST) on the finished goods can be zero-rated, further promoting exports and facilitating ease of doing business in India.
  </p>

</section>


  {/* ================= ADVANTAGES ================= */}
  <section className="moowr-section" id="sec1">
  <h2 className="green-title">Advantages of bonded warehousing</h2>

  <h1 className="highlight-title">Highlights</h1>

  <div className="advantage-grid">

    <div className="adv-card purple">
      <div className="icon-circle">📦</div>
      <h3>Deferred Duty on Imported Capital Goods</h3>
      <span className="more">+ More</span>
    </div>

    <div className="adv-card green">
      <div className="icon-circle">📄</div>
      <h3>Deferred Duty on Imported raw materials</h3>
      <span className="more">+ More</span>
    </div>

    <div className="adv-card red">
      <div className="icon-circle">💱</div>
      <h3>Warehouse to warehouse duty free transfer allowed</h3>
      <span className="more">+ More</span>
    </div>

    <div className="adv-card blue">
      <div className="icon-circle">📜</div>
      <h3>No fixed obligations</h3>
      <span className="more">+ More</span>
    </div>

  </div>

                      {/* ================= EASE OF BONDED MANUFACTURING ================= */}
<section className="eassy-section">

  <h1 className="ease-title">Ease of bonded manufacturing</h1>

  <div className="ease-item">
    <div className="ease-icon">📋</div>
    <div>
      <h3>Single point of approval</h3>
      <p>
        The Commissioner of Customs serves as the sole point of contact for obtaining approvals and permits related to bonded manufacturing facilities. This centralized approach streamlines the approval process, minimizing the need to interact with multiple authorities, and enhances the ease of doing business in bonded manufacturing facilities.
      </p>
    </div>
  </div>

  <div className="ease-item">
    <div className="ease-icon">📄</div>
    <div>
      <h3>Common form</h3>
      <p>
        A common application cum approval form is used to apply for a license for a private bonded facility, as well as permission for manufacturing and other operations. This integrated form simplifies the application process by combining the requirements for obtaining a license for a bonded facility and permission for manufacturing and other operations into a single form. This streamlined approach reduces paperwork, saves time, and enhances the ease of obtaining necessary approvals for setting up and operating a bonded manufacturing facility.
      </p>
    </div>
  </div>

  <div className="ease-item">
    <div className="ease-icon">🏭</div>
    <div>
      <h3>Unlimited period of warehousing</h3>
      <p>
        Both capital and non-capital goods, such as raw materials and components, can be warehoused in a bonded manufacturing facility until they are cleared for consumption or utilized in the manufacturing process. This allows businesses to store their goods in the bonded facility without paying import duties until they are ready to be consumed or used in production. This flexibility provides cost-effective inventory management options and enhances operational efficiency in bonded manufacturing facilities, contributing to the ease of conducting operations.
      </p>
    </div>
  </div>

  <div className="ease-item">
    <div className="ease-icon">📍</div>
    <div>
      <h3>No geographical restriction</h3>
      <p>
       A new manufacturing facility can be established or an existing facility can be converted into a bonded manufacturing facility in any location across India. There are no geographical restrictions on setting up or converting a facility into a bonded manufacturing facility, providing businesses with the flexibility to choose the most suitable location for their operations. This allows for efficient utilization of existing infrastructure or the establishment of new facilities based on business needs, contributing to the ease of establishing and operating bonded manufacturing facilities in India.
      </p>
    </div>
  </div>

  <div className="ease-item">
    <div className="ease-icon">✔</div>
    <div>
      <h3>Easy compliance</h3>
      <p>
        All records of manufacturing and other operations in a bonded manufacturing facility are to be maintained digitally in a standardized format. This requirement ensures uniformity and consistency in record-keeping practices, simplifies data management, and facilitates easy access and retrieval of information. Digitally maintaining records in a single format streamlines compliance procedures reduces paperwork, and enhances transparency and accountability in bonded manufacturing operations, contributing to the ease of doing business.
      </p>
    </div>
  </div>

</section>
</section>


  {/* ================= TYPES OF BENEFICIARIES ================= */}
 <section className="moowr-section" id="sec2">

  <h2 className="green-title">Types of Beneficiaries</h2>

  <p className="benefit-intro">
    Bonded manufacturing offers customs duty exemptions on imported inputs used in the production of finished goods meant for export, making it accessible to businesses of all types. For goods intended for domestic consumption, the duty on imported inputs is deferred until the finished goods are cleared for the domestic market. This allows businesses to benefit from reduced production costs through duty exemptions for export goods and manage cash flow effectively with deferred duty payment for domestic consumption. Bonded manufacturing thus provides businesses with opportunities to optimize their operations and enhance competitiveness in both domestic and international markets.
  </p>

  <p className="benefit-sub">
    For a better understanding, the illustrations below show how a manufacturer
    benefits from bonded manufacturing.
  </p>

  {/* BENEFIT CARD */}
  <div className="benefit-main-box">

    {/* HEADER */}
    <div className="benefit-header">
      <img
        src="https://cdn-icons-png.flaticon.com/512/1995/1995574.png"
        alt="helmet"
      />
      <h3>Manufacturer</h3>
      <span>−</span>
    </div>

    {/* CONTENT */}
    <div className="benefit-content">

      <div className="bullet-row">
        <span className="dot"></span>
        <p>
         A prominent Japanese automobile manufacturer has expressed interest in setting up a manufacturing facility in India. They have filed an application for licensing a facility near Nagpur, Maharashtra, and have imported required inputs such as airbags, gearboxes, and capital goods for production. The duty on these imports is deferred, providing additional working capital support to the manufacturer.
        </p>
      </div>

      <div className="bullet-row">
        <span className="dot"></span>
        <p>
          The manufacturer exports 70% of the total vehicles produced, and the deferred duty on these exported vehicles is waived. However, for the remaining 30% of vehicles sold domestically across India, the deferred customs duty and integrated goods and services tax (IGST) are paid at the time of sale.
        </p>
      </div>

      <div className="bullet-row">
        <span className="dot"></span>
        <p>
         The manufacturer benefits from the deferred duty on imported inputs, which helps to reduce production costs due to duty-free imports. This allows them to optimize their operations, enhance competitiveness, and effectively manage cash flow with the deferred duty payment option. The manufacturer's utilization of bonded manufacturing provides them with financial advantages and supports their goal of manufacturing vehicles in India.
        </p>
      </div>

    </div>

  </div>

</section>


  {/* ================= STEPS TO START ================= */}
 <section className="moowr-section" id="sec3">

  <h2 className="green-title">Steps to Start Manufacturing</h2>

  <div className="steps-timeline">

    {/* STEP 1 */}
    <div className="step-row">
      <div className="step-icon">
        <img src="https://cdn-icons-png.flaticon.com/512/942/942748.png" alt="moowr scheme" />
      </div>

      <div className="step-content">
        <h4>STEP ONE</h4>
        <h3>Submit Online Application</h3>

        <ul>
          <li>Nature of manufacturing</li>
          <li>Details of imported inputs</li>
          <li>Anticipated trade volume, etc.</li>
                  </ul>
                  
                  <h3>List of Required Documents:</h3>

                  <ul>
                    <li>Certificate of Incorporation (for companies)</li>
                    <li>Memorandum of Understanding (MoU) and Articles of Association (AoA) (for partnership firms)</li>
                    <li>Partnership Deed (for partnership firms)</li>
                    <li>Copy of ID proofs of proprietors/partners/directors</li>
                    <li>Copy of Aadhar Card of Authorized Signatory</li>
                    <li>Documents supporting property-holding rights, such as rent agreement</li>
                    <li>Copy of warehouse license, if previously issued</li>
                    <li>Ground plan of the site with details</li>
                    <li>Fire safety audit certificate</li>
                    <li>Compliance Icon</li>
                  </ul>
      </div>
    </div>

    {/* STEP 2 */}
    <div className="step-row">
      <div className="step-icon">
        <img src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"  alt="moowr scheme"/>
      </div>

      <div className="step-content">
        <h4>STEP TWO</h4>
        <h3>Execute a Bond</h3>

        <ul>
          <li>Execute a bond and submit physical copy to customs</li>
          <li>Maintain detailed accounts</li>
        </ul>

        <p className="note">
          <strong>Note:</strong> A Customs Officer will visit the facility to evaluate compliance before the bond is executed and the license is issued.
        </p>
      </div>
    </div>

    {/* STEP 3 */}
    <div className="step-row">
      <div className="step-icon">
        <img src="https://cdn-icons-png.flaticon.com/512/2921/2921222.png" alt="moowr scheme" />
      </div>

      <div className="step-content">
        <h4>STEP THREE</h4>
        <h3>Grant of Sanction</h3>

        <ul>
          <li>The Commissioner of Customs grants permission for manufacturing or other operations in the bonded facility.</li>
                    <li>Permission includes:</li>
                    <ul className="sub-list">
                      <li>Manufacturing process or other operations permitted</li>
                      <li>Conditions regarding manufacturing</li>
                      <li>Approved Icon</li>
                    </ul>
        </ul>
      </div>
    </div>

    {/* STEP 4 */}
    <div className="step-row">
      <div className="step-icon">
        <img src="https://cdn-icons-png.flaticon.com/512/190/190411.png" alt="moowr scheme" />
      </div>

      <div className="step-content">
        <h4>STEP FOUR</h4>
        <h3>Commence Manufacturing or Other Operations</h3>

        <p>
          Process for obtaining bonded facility license and manufacturing
          permission is combined into a single application.
        </p>
      </div>
    </div>

  </div>

</section>


  {/* ================= CLEARANCE ================= */}
  <section className="moowr-section" id="sec4">

  <h2 className="green-title">
    Steps for Clearance of Warehoused Goods
  </h2>

  {/* TOP COLORED BOXES */}
  <div className="clearance-top">

    <div className="top-box blue">
      <h4>FOR USE IN THE DOMESTIC MARKET</h4>
      <p>
        When goods stored in a bonded facility are utilized for
        manufacturing or other operations and intended for domestic
        consumption.
      </p>
    </div>

    <div className="or-circle">OR</div>

    <div className="top-box green">
      <h4>FOR EXPORT FROM THE CUSTOMS STATION</h4>
      <p>
        Goods intended for export from customs station.
      </p>
    </div>

    <div className="or-circle">OR</div>

    <div className="top-box blue">
      <h4>FOR TRANSFER TO ANOTHER BONDED MANUFACTURING FACILITY</h4>
      <p>
        Goods used as raw materials by another bonded facility.
      </p>
    </div>

  </div>

  {/* BOTTOM CONTENT */}
  <div className="clearance-bottom">

    {/* LEFT TEXT CONTENT */}
    <div className="left-content">

      <h3>Clearance of Warehoused Goods for Domestic Consumption </h3>
<p>Goods stored in a warehouse can be used for consumption within the country or sold in the local market only if the following requirements are met:</p>

      <ul>
        <li>A bill of entry for home consumption has been filed in the specified format.</li>
        <li>All applicable import duty, penalties, rent, interest, and other charges for the goods have been paid.</li>
        <li>An order for clearance of the goods for domestic consumption has been issued by the authorized officer.</li>
      </ul>

      <h3>Clearance of warehoused goods for Export </h3>
        
<p>Goods stored in a warehouse can be exported to a destination outside India without payment of import duty if the following conditions are fulfilled:</p>

      <ul>
        <li>A shipping bill or a bill of export has been filed for the goods in the prescribed format.</li>
        <li>All export duty, penalties, rent, interest, and other charges for the goods have been paid.</li>
        <li>An order for clearance of the goods for exportation has been issued by the authorized officer.</li>
      </ul>

    </div>

    {/* RIGHT NUMBER CARDS */}
    <div className="right-steps">

  {stepData.map((text, index) => (
    <div key={index} className="step-card">

      <div className="step-number">
        {index + 1}
      </div>

      <p>{text}</p>

    </div>
  ))}

</div>

  </div>

                  </section>

                   {/* essentials section */}

    <section className="essentials-section" id="sec5">

      <h2 className="green-title">
        Essentials to Benefit from Bonded Manufacturing
      </h2>

      {items.map((item, index) => (
        <div className="essential-card" key={index}>

          {/* HEADER */}
          <div
            className="essential-header"
            onClick={() => setOpen(open === index ? null : index)}
          >
            <div className="icon-circle">📦</div>

            <h3>{item.title}</h3>

            <span className="toggle">
              {open === index ? "−" : "+"}
            </span>
          </div>

          {/* CONTENT */}
          {open === index && (
            <div className="essential-content">
              {item.content}
            </div>
          )}

        </div>
      ))}

    </section>
  

  {/* ================= RECORD KEEPING ================= */}
  <section className="record-section" id="sec6">
  <h2 className="record-title">Requirements for Record-keeping</h2>

  <div className="record-grid">

    {/* CARD 1 */}
    <div className="record-card">
      <div className="record-header">
        1. Maintenance of records
      </div>

      <div className="record-body">
        <ul>
          <li>Maintain comprehensive records of receipt, handling, storage and removal of goods.</li>
          <li>Document all activities related to warehoused goods.</li>
          <li>Record withdrawal of samples from warehoused goods.</li>
          <li>Retain copies of:
            <ul className="sub-list">
              <li>Bills of Entry</li>
              <li>Transport documents</li>
              <li>Transfer forms</li>
              <li>Shipping Bills</li>
              <li>Bills of Export</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>

    {/* CARD 2 */}
    <div className="record-card">
      <div className="record-header">
        2. Preservation of physical and digital records
      </div>

      <div className="record-body">
        <ul>
          <li>Maintain accurate and updated records and accounts.</li>
          <li>Preserve records for minimum 5 years from removal date.</li>
          <li>Maintain digital backup outside facility for safety.</li>
        </ul>
      </div>
    </div>

    {/* CARD 3 */}
    <div className="record-card">
      <div className="record-header">
        3. Filing monthly returns
      </div>

      <div className="record-body">
        <ul>
          <li>Submit monthly returns within 10 days of each month end.</li>
        </ul>
      </div>
    </div>

  </div>

  <p className="record-footer">
    Licensees who do not comply with any provisions will be subject to penalties.
  </p>
</section>

</div>
      </div>
    </div>
  );
}